import script from "./SidePanelDataFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanelDataFields.vue?vue&type=script&setup=true&lang=js"

import "./SidePanelDataFields.vue?vue&type=style&index=0&id=5ad38136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad38136"]])

export default __exports__